<template>
  <div class="edrea_tm_section" id="about">
    <div class="section_inner">
      <div class="edrea_tm_about">
        <div class="left">
          <div class="image">
            <img src="img/thumbs/1-1.jpg" alt="" />
            <div class="main" data-img-url="img/about/main.jpg"></div>
          </div>
        </div>
        <div class="right">
          <div class="short">
            <h3 class="name">ORIQY<span class="coloring">AGENCY</span></h3>
            <h3 class="job">
              <AnimationText />
            </h3>
          </div>
          <div class="text">
           <p>
  Dominamos os mercados de alta concorrência com uma <span>gestão estratégica incomparável</span> e expertise de elite em marketing. Potencializamos operações consolidadas e construímos novas máquinas de receita. <br>Enquanto a concorrência tenta acompanhar, nós ditamos o ritmo.
</p>
          </div>
          <div class="edrea_tm_button" id="aboutPopup">
            <a href="#">Saiba Mais</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimationText from "./AnimationText.vue";
export default {
  name: `AboutComponent`,
  data() {
    return {
      open: false,
    };
  },
  components: {
    AnimationText,
  },
};
</script>

<style scoped>
.edrea_tm_modalbox {
  top: -90px;
}
</style>
